/* eslint-disable no-unused-vars */

import { inspectionActions } from '@redux/slices/inspection';
import { jurisdictionNumbersActions } from '@redux/slices/jurisdiction-numbers';
import { checkOldAndNewArray } from '@services/check-old-and-new-array';
import { getAppDispatch } from '@utilities/dispatch.util';
import { store } from 'redux/store';

const jurisdictionNumbersJsonManipulation = ({ data, initialLogin, isSettingUpdated }) => {
  const { items = [] } = data;

  const {
    jurisdictionNumbers: oldJurisdictionNumbers,
    jurisdictionNumbersMap: oldJurisdictionNumbersMap
  } = store.getState()?.jurisdictionNumbers || {};

  const isCheckOldAndNewArray =
    !initialLogin && oldJurisdictionNumbers?.length && !isSettingUpdated;

  let newList = [];

  newList = !isCheckOldAndNewArray
    ? items?.map((task) => {
        const found =
          oldJurisdictionNumbers.findIndex((t) => t.equipmentId === task.equipmentId) + 1;

        if (found && oldJurisdictionNumbers[found - 1].isEdit) {
          return { ...oldJurisdictionNumbers[found - 1] };
        } else {
          return task;
        }
      })
    : items?.length === 0
    ? oldJurisdictionNumbers
    : items;

  let newNumber = oldJurisdictionNumbers?.filter((x) => x?.isNew) || [];

  newList = [...newList, ...newNumber];

  const jurisdictionNumbers = newList || [];
  const jurisdictionNumbersMap = jurisdictionNumbers.reduce((acc, curr) => {
    acc[curr.equipmentId] = curr;
    return acc;
  }, {});

  return {
    jurisdictionNumbers,
    jurisdictionNumbersMap
  };
};

const jurisdictionNumbersDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(jurisdictionNumbersActions.setJurisdictionNumbers(data));
  dispatch?.(inspectionActions.setInspectionJurisdictionNumbers(data?.jurisdictionNumbers));
};

export { jurisdictionNumbersJsonManipulation, jurisdictionNumbersDispatcher };
